<template>
  <div class="goods-list">
    <div class="mgr">
      <div class="amount-surplus">
        <div class="balance" @click="handleClickShowTip(false)">
          余额 <i></i> {{ amount.quizRemainNum > 999999 ? '999999' : amount.quizRemainNum }}
        </div>
        <div class="surplus" @click="handleClickShowTip(true)">
          <i class="saishi"></i> {{ amount.matchRemainNum }}
        </div>
        <div v-if="showPopup" class="popup">
          <div class="popup-content">
            <!-- <span>
              {{ tipTxt=== false ? '可用于参与竞猜、送礼;获取途径：参与赛事中心活动、竞猜，游戏内活动获得。' : '可用于参与赛事转盘，获取后需前往游戏内邮箱领取方可到账;获取途径：参与赛事中心活动，游戏内购买获得。' }}
            </span> -->
            <span v-if="tipTxt">
              可用于参与赛事转盘，获取后需前往游戏内邮箱领取方可到账;<br/>获取途径：参与赛事中心活动，游戏内购买获得。
            </span>
            <span v-else>
              可用于参与竞猜、送礼 <br/>获取途径：参与赛事中心活动、竞猜，游戏内活动获得。
            </span>
          </div>
        </div>
      </div>
      <GoodsList :goodsList="mall.goodsList" :title="'每日商城'" @exchange="exchange" type="mall" />
      <GoodsList :goodsList="mall.resident" :title="'常驻商城'" @exchange="exchange" type="resident" />
    </div>

  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useAppStore } from '@/store'
import { usePrompt } from '@/composables/usePrompt'
import GoodsList from './goods-list.vue'

defineOptions({ name: 'goodsList' })

const appStore = useAppStore()

const showPopup = ref(false)
const tipTxt = ref(false)
const tipock = ref(false)

const { showPrompt } = usePrompt()

const amount = computed(() => appStore.amount)
const mall = computed(() => appStore.mall)

// created
appStore.getGoodsList()

function exchange(goods, type) {
  let isType = type === 'mall' ? true : false
  let goodList = goods
  let limit = isType ? goodList.dailyLimit - goodList.dailyReward : goodList.totalLimit - goodList.totalReward
  //  赛事币
  if (limit > 0) {
    if (amount.value.quizRemainNum >= goodList.cost) {
      // this.$refs.exchange.exchange(goodList, type)
      appStore.openModal({
        id: 'store-exchange',
        params: {
          goodList: goodList,
          type: type
        }
      })
      // 埋点
      // if (typeof tapdb === 'undefined') return
      // tapdb.trackEvent('点击查看商品', {
      //   '#item_id': goodList.desc
      // })
    } else {
      showPrompt('竞猜币不够，稍后再来吧～')
    }
  } else {
    isType ? showPrompt(
      `已达兑换上限～ （${goodList.dailyReward}/${goodList.dailyLimit}）`
    ) :
      showPrompt(
        `已达兑换上限～ （${goodList.totalReward}/${goodList.totalLimit}）`
      )
  }
}
function handleClickShowTip(value) {
  if(!tipock.value){
    tipock.value = true
    showPopup.value = true
    tipTxt.value = value
    setTimeout(() => {
      showPopup.value = false
      tipock.value = false
    }, 3000)
  }
}
</script>


<style lang="scss" scoped>
.goods-list {
  overflow: scroll;
  height: 100%;

  .mgr {
    position: relative;
    overflow-y: scroll;
  }

  .amount-surplus {
    box-sizing: border-box;
    position: absolute;
    // top: get_vh(25);
    // right: get_vh(15);
    top: 0;
    right: 0;
    display: inline-flex;
    justify-content: flex-end;
    align-items: center;
    height: get_vw(40);
    line-height: get_vw(40);
    background-color: rgba(#000, 0.5);
    border: get_vw(2) solid rgba(#fff, 0.2);
    border-radius: get_vw(10);
    padding: 0 get_vw(14);
    color: #fff;
    font-size: get_vw(20);
    z-index: 1;

    .balance {
      display: inline-flex;
      justify-content: flex-end;
      align-items: center;

      i {
        display: inline-block;
        @include icon_status('quiz_coin');
        margin: 0 get_vw(10);
        width: get_vw(24);
        height: get_vw(26);
      }
    }

    .surplus {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      i {
        display: inline-block;
        @include icon_status('quiz_coin');
        margin: 0 get_vw(10);
        width: get_vw(26);
        height: get_vw(27);
      }

      .saishi {
        background-image: url('https://website.xdcdn.net/poster/355916/sausage-match/FwfgNkZW.png');
      }
    }

    .popup{
      width: get_vw(300);
      border-radius: get_vw(10);
      background: rgba(0, 0, 0, 0.8);
      position: absolute;
      top: get_vw(50);
      right: 0;
      .popup-content{
        text-align: left;
        font-size: get_vw(16);
        line-height: get_vw(24);
        color: #fff;
        margin: get_vw(8)
      }
    }
  }
}
</style>
